import React from 'react'
import { CircularProgress, Box } from '@mui/material'

const Loading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 40,
      }}>
      <CircularProgress disableShrink sx={{ m: 2 }} size={40} />
    </Box>
  )
}

export default Loading
